import { PLACEHOLDER_RANGE_FOCUSED as a, PLACEHOLDER_RANGE as E } from "./index.es652.js";

var c = function c(_ref) {
  var e = _ref.isFocused,
      r = _ref.isOpen,
      t = _ref.placeholder;
  return e || r ? a : t || E;
},
    i = function i(e) {
  return !Number.isNaN(Date.parse(e));
};

export { c as calculatePlaceholder, i as isValidDate };